import { render, staticRenderFns } from "./IconNotifications.vue?vue&type=template&id=f69007f4&"
import script from "./IconNotifications.vue?vue&type=script&lang=js&"
export * from "./IconNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports